
<div class="wrapper" *ngIf="currentUser; else notReady">
    <div *ngIf="sessionStarted; else Initializing">
        <mat-sidenav-container class="wrapper">
            <mat-sidenav mode="side" opened class="sidenav" [fixedInViewport]="Fixed">
                <app-navbar></app-navbar>
            </mat-sidenav>
            <mat-sidenav-content>
                <app-topbar></app-topbar>
                <div class="container">
                    <router-outlet></router-outlet>
                </div>
            </mat-sidenav-content>
        </mat-sidenav-container>            
    </div>

    <ng-template #Initializing>
        <div class="flex-container-row wrapper-login" fxFlexFill>
            <div class="row row-wait" fxLayout="column">
                <div fxFlex="25"></div>
                <div fxFlex="50">
                    <table width="100%">
                        <tr>
                            <td class="text-center">
                                    <mat-spinner color="accent" [diameter]="50"></mat-spinner>
                            </td>
                        </tr>
                    </table>
                </div>
                <div fxFlex="25"></div>
            </div>
        </div>
    </ng-template>

</div>


<ng-template #notReady>
    <div class="wrapper-login">
        <router-outlet></router-outlet>
    </div>
</ng-template>

